<app-banner-app [retroSelected]="true"></app-banner-app>
<br><br><br><br><br><br>

<div class="container">
    <br><br>
    <div class="row">
        <div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0">
            <div class="aliniacionTexto">
                <br><br><br><br>
                <span class="pagina__texto-principal">¡Hola Ana! Bienvenida al proceso de</span><br>
                <span class="textoSeguroMedio">Seguro de<br>arrendamiento SURA</span>
                <div class="desktop"><br><br></div>

            </div>

            <div>
                <span class="textoIzquierdoBajo">
                    Revisa la información brindada y avanza para completar la firma de tu contrato
                </span>
            </div>
        </div>

        <div class="col">
            <div class="card card__sombreado-propio">
                <div class="card-header estiloCardBanner">
                    <div class="container">
                        <div class="row" style="padding-top: 5px; padding-bottom: 7px;">
                            <div class="col">
                                <div class="estiloTextoBanner">
                                    <div class="banner__Texto-titulo">Detalle del seguro</div>
                                </div>
                            </div>
                            <img name="logo" class="img-responsive" src="./assets/img/Capa_1-2-Logo.svg"
                                style="width: 30%;">
                        </div>
                    </div>
                </div>

                <div class="card-body" style="margin-left: 10px; margin-right: 30px;">
                    <br>
                    <span class="seccion-dos__texto-superior">
                        <div class="row">
                            <div class="col tipografiaCard">
                                Propietario:
                            </div>
                            <div class="col textoDetalleTipografia" style="margin-left: 70px;">
                                {{ this.datosGenerales.Propietario.primerNombre + ' ' +
                                this.datosGenerales.Propietario.segundoNombre + ' ' +
                                this.datosGenerales.Propietario.primerApellido + ' ' +
                                this.datosGenerales.Propietario.segundoApellido }}
                            </div>
                        </div>
                    </span><br>

                    <span class="seccion-dos__texto-superior">
                        <div class="row">
                            <div class="col tipografiaCard">
                                Dirección:
                            </div>
                            <div class="col textoDetalleTipografia" style="margin-left: 70px;">
                                {{ this.datosGenerales.Inmueble.direccion }}
                            </div>
                        </div>
                    </span><br>

                    <span class="seccion-dos__texto-superior">
                        <div class="row">
                            <div class="col tipografiaCard">
                                Ciudad:
                            </div>
                            <div class="col textoDetalleTipografia" style="margin-left: 70px;">
                                {{ this.datosGenerales.Inmueble.ciudad }}
                            </div>
                        </div>
                    </span><br>

                    <span class="seccion-dos__texto-superior">
                        <div class="row">
                            <div class="col tipografiaCard">
                                Nombre del inquilino:
                            </div>
                            <div class="col textoDetalleTipografia" style="margin-left: 70px;">
                                {{ this.datosGenerales.Inquilino.primerNombre + ' ' +
                                this.datosGenerales.Inquilino.segundoNombre + ' ' +
                                this.datosGenerales.Inquilino.primerApellido + ' ' +
                                this.datosGenerales.Inquilino.segundoApellido }}
                            </div>
                        </div>
                    </span><br>

                    <span class="seccion-dos__texto-superior">

                        <div class="row">
                            <div class="col tipografiaCard">
                                Vigencia del seguro:
                            </div>
                            <div class="col textoDetalleTipografia" style="margin-left: 70px;">
                                {{ this.datosGenerales.InfoArrendamiento.duracionContrato }}  meses
                            </div>
                        </div>
                    </span><br>

                    <br>
                    <div>
                        <span class="tipografiaTotal">El valor total del canon asegurado es</span>
                        <br>
                        <span class="tipValorTotal">{{ this.datosGenerales.PlanSeleccionado.valorPlan | currency: 'USD' }}</span>
                    </div>
                    <br>
                </div>
            </div>
            <br><br>

            <div style="width: 70%;" class="container">
                <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit">Continuar</button>
            </div>
        </div>
    </div>

</div>

<br><br><br>
<app-footer-app></app-footer-app>